import Progress from 'redux-progress';
import { MACMarketplaceAction, MACMarketplaceState } from '../models/marketplace';
import { VENDOR_TERM_LINK } from '../actions/marketplace';

export const initialState = {
  vendorDetails: Progress.none,
};

export default (
  state: MACMarketplaceState = initialState,
  action: MACMarketplaceAction,
): MACMarketplaceState => {
  switch (action.type) {
    case VENDOR_TERM_LINK:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          [action.productKey]: action.progress,
        },
      };
    default:
      return state;
  }
};
